import { gql } from '@apollo/client'

export const sendPaylink = gql`
  mutation sendPaylink($id: String!, $email: String!, $note: String!) {
    sendPaylink(id: $id, email: $email, note: $note) {
      id
    }
  }
`

export const updateCharityCustom = gql`
  mutation updateCharityCustom($id: String!, $data: UpdateCharityInput!) {
    updateCharityCustom(id: $id, data: $data) {
      id
      designationCode
      categoryCode
      subcategoryCode
      accountName
      legalName
      mailingAddress
      city
      province
      country
      postalCode
      contactPhoneNumber
      emailAddress
      websiteAddress
      active
    }
  }
`

export const removeCharityBankAccount = gql`
  mutation removeCharityBankAccount($id: String!, $paymentMethodId: Float!) {
    removeCharityBankAccount(id: $id, paymentMethodId: $paymentMethodId)
  }
`

export const inviteCharityToSignUp = gql`
  mutation inviteCharityToSignUp($charityId: String!, $email: String!, $note: String!) {
    inviteCharityToSignUp(charityId: $charityId, email: $email, note: $note) {
      id
      email
    }
  }
`

export const inviteCharityToSignUpCharityPortal = gql`
  mutation inviteCharityToSignUpCharityPortal($charityId: String!, $email: String!, $note: String!) {
    inviteCharityToSignUpCharityPortal(charityId: $charityId, email: $email, note: $note) {
      id
      email
    }
  }
`

export const acceptExistingCharityInvite = gql`
  mutation AcceptExistingCharityInvite($data: ValidateInviteTokenInput!) {
    acceptExistingCharityInvite(data: $data)
  }
`

export const declineCharityInvite = gql`
  mutation declineCharityInvite($charityInviteId: Int!) {
    declineCharityInvite(charityInviteId: $charityInviteId)
  }
`

export const revokeInvite = gql`
  mutation revokeInvite($id: Float!) {
    revokeInvite(id: $id) {
      id
    }
  }
`
export const revokeInviteCharityPortal = gql`
  mutation revokeInviteCharityPortal($id: Float!) {
    revokeInviteCharityPortal(id: $id) {
      id
    }
  }
`

export const revokeCharityUserAccess = gql`
  mutation revokeCharityUserAccess($charityUserId: Float!) {
    revokeCharityUserAccess(charityUserId: $charityUserId) {
      id
    }
  }
`

export const restoreCharityUserAccess = gql`
  mutation restoreCharityUserAccess($charityUserId: Float!) {
    restoreCharityUserAccess(charityUserId: $charityUserId) {
      id
    }
  }
`

export const setActiveOverride = gql`
  mutation setActiveOverride($id: String!, $isActiveOverride: String!) {
    setActiveOverride(id: $id, isActiveOverride: $isActiveOverride) {
      id
    }
  }
`

export const setGiveGeniusEnabled = gql`
  mutation setGiveGeniusEnabled($id: String!, $enabled: Boolean!) {
    setGiveGeniusEnabled(id: $id, enabled: $enabled) {
      id
      giveGeniusEnabled
    }
  }
`

export const getCharityAiDescription = gql`
  mutation getCharityAiDescription($id: String!) {
    getCharityAiDescription(id: $id)
  }
`

export const getCharityAiLogos = gql`
  mutation getCharityAiLogos($id: String!) {
    getCharityAiLogos(id: $id)
  }
`

export const updateCharityDescription = gql`
  mutation updateCharityDescription($data: UpdateCharityDescriptionInput!) {
    updateCharityDescription(description: $data) {
      charityId
      description
      tagline
    }
  }
`

export const updateCharityLogo = gql`
  mutation updateCharityLogo($data: UpdateCharityAssetInput!) {
    updateCharityLogo(data: $data) {
      charityId
      logoPath
      imagePath
      logo
    }
  }
`
export const updateMyCharityDescription = gql`
  mutation updateMyCharityDescription($data: UpdateCharityDescriptionInput!) {
    updateMyCharityDescription(description: $data) {
      charityId
      description
      tagline
    }
  }
`

export const updateMyCharityProfile = gql`
  mutation updateMyCharityProfile($data: UpdateCharityProfileInput!) {
    updateMyCharityProfile(data: $data) {
      charityId
      logoBackgroundColor
    }
  }
`

export const updateMyCharityCategories = gql`
  mutation updateMyCharityCategories($charityId: String!, $categories: [Int!]!) {
    updateMyCharityCategories(charityId: $charityId, categories: $categories) {
      id
      categories {
        category {
          id
          name
        }
      }
    }
  }
`

export const updateMyCharityLogo = gql`
  mutation updateMyCharityLogo($data: UpdateCharityAssetInput!) {
    updateMyCharityLogo(data: $data) {
      charityId
      logoPath
      imagePath
      logo
    }
  }
`

export const generateLandingPage = gql`
  mutation generateLandingPage($id: String!, $templateName: String!) {
    generateLandingPage(id: $id, templateName: $templateName)
  }
`

export const createPurposeOfGift = gql`
  mutation createPurposeOfGift($data: CreatePurposeOfGiftInput!) {
    createPurposeOfGift(data: $data) {
      id
      reason
      active
    }
  }
`

export const updatePurposeOfGift = gql`
  mutation updatePurposeOfGift($data: [UpdatePurposeOfGiftInput!]!) {
    updatePurposeOfGift(data: $data) {
      id
      reason
      active
    }
  }
`

export const deletePurposeOfGift = gql`
  mutation deletePurposeOfGift($id: Float!) {
    deletePurposeOfGift(id: $id) {
      id
      reason
      active
    }
  }
`

export const updateSocialMediaLink = gql`
  mutation updateSocialMediaLink($id: Int!, $link: String!, $platform: String!, $charityId: String!) {
    updateSocialMediaLink(id: $id, link: $link, platform: $platform, charityId: $charityId) {
      id
      link
      platform
      charityId
    }
  }
`
export const createSocialMediaLink = gql`
  mutation createSocialMediaLink($data: CreateSocialMediaLinkInput!) {
    createSocialMediaLink(data: $data) {
      link
      platform
      charityId
    }
  }
`

export const createCharity = gql`
  mutation createCharity($data: CreateCharityInput!) {
    createCharity(data: $data) {
      id
      accountName
      legalName
      contactName
      country
      province
      city
      mailingAddress
      postalCode
      contactPhoneNumber
      emailAddress
      websiteAddress
      categoryCode
      designationCode
      charitySource
      isNqd
    }
  }
`

export const updateCharityPaymentMethodSettings = gql`
  mutation updateCharityPaymentMethodSettings(
    $charityId: String!
    $disabledMethods: [String!]
    $customOrder: JSONObject
    $defaultMethod: String
  ) {
    updateCharityPaymentMethodSettings(
      charityId: $charityId
      disabledMethods: $disabledMethods
      customOrder: $customOrder
      defaultMethod: $defaultMethod
    ) {
      disabledMethods
      customOrder
      defaultMethod
    }
  }
`

// FLIGHT-33: bulk-push charity data to the public Generosity Pages import API.
// charityIds omitted pushes every eligible charity (same scope as the JSON export below).
// Queued through the scheduler (not pushed synchronously) - check Management >
// Communications > Scheduled Comms for status/history on the returned comm.
export const pushCharityImportNow = gql`
  mutation pushCharityImportNow($charityIds: [String!], $notify: Boolean) {
    pushCharityImportNow(charityIds: $charityIds, notify: $notify) {
      id
      status
      scheduledFor
    }
  }
`
